import { css, type Theme } from "@emotion/react";

export const sidebarToggle = css`
  background: none;
  border: none;
  height: 100%;
  padding: 0;
  cursor: pointer;
`;

export const EmersonSidebarToggle = css`
  width: 44px;
  height: 44px;
`;

export const hamburger = (theme: Theme) => css`
  &&& {
    width: 1.8125rem;
    height: 100%;
    margin-bottom: -0.125rem;
  }

  path {
    fill: ${theme.text.body};
  }
`;

export const EmersonNavBurger = css`
  &&& {
    width: 1rem;
  }
`;
